
import { Card } from "@/components/ui/card";
import { Progress } from "@/components/ui/progress";
import { RankDisplay } from "./RankDisplay";
import { useTranslation } from "@/hooks/useTranslation";

interface AirportStatsProps {
  rank: number;
  handCheckRate: number;
  totalReviews: number;
}

export const AirportStats = ({ rank, handCheckRate, totalReviews }: AirportStatsProps) => {
  const { t } = useTranslation();
  
  return (
    <Card className="p-6 mb-8">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="flex flex-col items-center justify-center">
          <p className="text-sm text-muted-foreground mb-2">{t('rank')}</p>
          <RankDisplay rank={rank} />
        </div>
        <div className="flex flex-col">
          <p className="text-sm text-muted-foreground mb-2">{t('hand_check_rate')}</p>
          <div className="flex items-center gap-2">
            <Progress 
              value={handCheckRate} 
              className="h-2 flex-1"
            />
            <span className="text-sm font-medium w-12 text-right">
              {handCheckRate.toFixed(0)}%
            </span>
          </div>
        </div>
        <div className="flex flex-col items-center justify-center">
          <p className="text-sm text-muted-foreground mb-2">{t('reviews')}</p>
          <p className="text-2xl font-bold">{totalReviews}</p>
        </div>
      </div>
    </Card>
  );
};
